import { appConfig } from "src/config";

export default {
  userPortalHomePage() {
    window.location.href = appConfig.USERPORTAL_URL;
  },
};
